import axios, { BASE_URL } from "../axios";

export default class ExtrasModel {
  static endPoint = "extras/";

  static getDataCount() {
    return axios.get(BASE_URL + this.endPoint + "get-coc-user-count");
  }

  static getTodayCount() {
    return axios.get(BASE_URL + this.endPoint + "get-coc-today-count");
  }

  static getRangeCount(startDate, endDate) {
    return axios.get(
      BASE_URL +
        this.endPoint +
        `get-coc-range-count?startDate=${startDate}&endDate=${endDate}`
    );
  }
}
